import 'arrayq';

import { PureConnect, PureFunctional, React } from '../../react';
// import { FontIcon } from 'react-toolbox/lib/font_icon/FontIcon';
import { IParticipant, IUsergroup, isParticipant, INote, isUsergroup } from '../../types';
import cx from './style.less';
import { participantsResource } from '../../participant/resource';
import windowSelectors from '../../window/selectors';
import selectors from './selectors';
import CANCEL from './actions/CANCEL';
import SELECT from './actions/SELECT';
import SELECT_GROUP from './actions/SELECT_USERGROUP';
import SEARCH_TERM from './actions/SEARCH_TERM';
import reselectors from './reselectors';
import reselectorsug from './reselectorsusergroup';
import { usergroupResource } from '../../usergroup/resource';
import SEARCH_TERM_USERGROUP from './actions/SEARCH_TERM_USERGROUP';
import { notesEditor } from '../notes/resource';
import CollapsiblePanel from '../collapsiblePanel';
import { Btn } from '../../react-toolbox-redesign/button';

function mapParticipantsNames(participantIds: string[], allparticipants: IParticipant[]) {
    let participantstring = '';

    const participants = allparticipants.qWhere((item) => participantIds ? participantIds.qIncludes(item.id) : false);
    participantstring = participants && participants.qAny() ?
        `${participants.map((x) => {
            return x.name;
        }).join(', ')}` :
        '';
    return participantstring;
}

function mapGroups(emailParticipantGroupIds: string[], allparticipantgroups: IUsergroup[]) {
    let groupsstring = '';
    const groups = allparticipantgroups.qWhere((item) => emailParticipantGroupIds ? emailParticipantGroupIds.qSelect((itm) => parseInt(itm)).qIncludes(item.id) : false);
    groupsstring =
        groups && groups.qAny() ?
            `${groups.map((x) => {
                return x.name;
            }).join(', ')}` :
            '';
    return groupsstring;
}

export default PureConnect<{
    label?: string;
}>(`ParticipantsDropdown`)(
    (state) => ({
        currentitem: notesEditor.selectors.item(state),
        participants: participantsResource.selectors.items(state),
        usergroups: usergroupResource.selectors.items(state),
        visible: selectors.visible(state),
    }),
    (dispatch) => ({
        change: (item: INote | any) => { dispatch(notesEditor.actions.APPLY({ item })); },
    }),
    ({ currentitem, change }) => {

        return (
            <span tabIndex={-1} className={cx('component', 'wrapped')}>
                <div className={cx('popupParticipantPopup')}>
                    <ParticipantSelectModel
                        selectedparticipantsIDs={currentitem && currentitem.noteParticipantsIDs ? currentitem.noteParticipantsIDs : []}
                        selectedparticipantgroupIDs={currentitem && currentitem.noteParticipantGroupIDs ? currentitem.noteParticipantGroupIDs : []}
                        onSelect={(c) => { currentitem.noteParticipantsIDs = c; change({ currentitem }); }}
                        onSelectGroup={(d) => { currentitem.noteParticipantGroupIDs = d; change({ currentitem }); }}
                    />
                </div>
            </span>
        );
    });

export const ParticipantSelectModel = PureConnect<{
    selectedparticipantsIDs: string[],
    selectedparticipantgroupIDs: string[],
    onSelect: (participantsids: string[]) => void;
    onSelectGroup: (participantgroupIDs: string[]) => void;
}>(`ParticipantSelectModel`)(
    (state) => ({
        alltheparticipants: reselectors.AllParticipantSelector(state),
        allsearchparticipants: reselectors.ParticipantSelector(state),
        alltheusergroups: reselectorsug.AllUsergroupSelector(state),
        allsearchusergroups: reselectorsug.UsergroupSelector(state),
        usergroups: usergroupResource.selectors.items(state),
        visible: selectors.visible(state),
        screenSmall: windowSelectors.small(state),
        searchTermParticipant: selectors.searchTermParticipantSelector(state),
        searchTermUsergroup: selectors.searchTermUsergroupSelector(state),
    }),
    (dispatch, { onSelect, onSelectGroup }) => ({
        cancel() { dispatch(CANCEL({})); },
        save() { dispatch(CANCEL({})); },
        select(participants: IParticipant[]) { onSelect(participants.qSelect((x) => x.id)); dispatch(SELECT({ participants })); },
        selectGroup(usergroups: IUsergroup[]) { onSelectGroup(usergroups.qSelect((y) => y.id.toString())); dispatch(SELECT_GROUP({ usergroups })); },
        updateSearchTerm: (searchTerm: string) => { dispatch(SEARCH_TERM({ searchTermParticipant: searchTerm })); },
        updateSearchTermGroup: (searchTerm: string) => { dispatch(SEARCH_TERM_USERGROUP({ searchTermUsergroup: searchTerm })); },
    }),
    ({ visible, searchTermParticipant, searchTermUsergroup, alltheparticipants, allsearchparticipants, selectedparticipantsIDs, alltheusergroups, allsearchusergroups, selectedparticipantgroupIDs, cancel, save, select, selectGroup, updateSearchTerm, updateSearchTermGroup }) => {
        const allparticipants: (any)[] = [];
        if (alltheparticipants && alltheparticipants.length)
            alltheparticipants.qWhere((itm) => allparticipants && !allparticipants.qAny((itmpart) => itmpart === itm)).map((itm) => allparticipants.push(itm));
        if (alltheusergroups && alltheusergroups.length)
            alltheusergroups.qWhere((itm) => allparticipants && !allparticipants.qAny((itmpart) => itmpart === itm)).map((ug) => allparticipants.push(ug));
        const theSelectedList: any[] = alltheparticipants.qWhere((participant) =>
            (selectedparticipantsIDs ? selectedparticipantsIDs.qIncludes(participant.id) : false));

        const notSelectedList: any[] = allsearchparticipants.qWhere((participant) =>
            (selectedparticipantsIDs ? !selectedparticipantsIDs.qIncludes(participant.id) : true));

        // the participants
        const theSelectedParticipantList: IParticipant[] = alltheparticipants.qWhere((participant) =>
            (selectedparticipantsIDs ? selectedparticipantsIDs.qIncludes(participant.id) : false));

        // the usergroups             
        const theSelectedUsergroupList: IUsergroup[] = alltheusergroups.qWhere((usergroup) =>
            (selectedparticipantgroupIDs ? selectedparticipantgroupIDs.qSelect((x) => parseInt(x)).qIncludes(usergroup.id) : false));
        theSelectedUsergroupList.map((tsu) => theSelectedList.push(tsu));

        const notSelectedUsergroupList: IUsergroup[] = allsearchusergroups.qWhere((usergroup) =>
            (selectedparticipantgroupIDs ? !selectedparticipantgroupIDs.qSelect((x) => parseInt(x)).qIncludes(usergroup.id) : true));

        notSelectedUsergroupList.map((nsu) => notSelectedList.push(nsu));

        return (
            <div className={cx(!(visible) ? 'wcag-invisible' : '', 'fields-container')} aria-hidden={!(visible)} aria-labelledby="Selecteer deelnemers">
                <section role="contentinfo" aria-label={'Sluit sectie'} className={cx('content-container')}>
                    <div className={cx('button-container')}>
                        <Btn
                            type="button"
                            className={cx('btn-icon-text_back', 'icon_arrow-back')}
                            // extraClassNames={['btn-icon-text_back', 'icon_arrow-back']} // Moet een <- icoon zijn
                            aria-label={'Terug gaan'}
                            aria-haspopup={true}
                            tabIndex={0}
                            onClick={cancel}
                            disabled={false}>
                            <span>Terug</span>
                        </Btn>
                    </div>
                </section>           
                <div className={cx('container')}>
                    <div className={cx('selectable-aria')}>
                        <div className={cx('share-with-persons')}>Deel met personen</div>
                        <section aria-label={'Selecteer deelnemer'} className={cx('bottom')}>
                            <CollapsiblePanel defaultOpened={false} label={theSelectedList.length ? mapParticipantsNames(selectedparticipantsIDs, allparticipants) : 'Selecteer'}>
                                <div className={cx('input-search-div')}>
                                    <div className={cx('input-search')}>
                                        <span className={cx('icon-search')}></span>
                                        <input placeholder="Zoeken..." name="q" ref="term" value={searchTermParticipant} onChange={(x) => updateSearchTerm(x.target.value)} />
                                    </div>
                                </div>
                                <section aria-label={'Deelnemers'} className={cx('top')}>
                                    <ParticipantAndUsergroupList label="" up={false}
                                        participants={theSelectedParticipantList}
                                        allparticipants={allparticipants}
                                        onClick={(p) => {                                            
                                            isParticipant(p) ?
                                                select(theSelectedParticipantList ? theSelectedParticipantList.qWhere((y) => y.id !== p.id) : []) :
                                                selectGroup(theSelectedUsergroupList ? theSelectedUsergroupList.qWhere((y) => y.id !== p.id) : []);
                                        }}
                                        onClickAdd={(p) => {
                                            isParticipant(p) ?
                                                select(theSelectedParticipantList ? theSelectedParticipantList.concat(p) : []) :
                                                selectGroup(theSelectedUsergroupList ? theSelectedUsergroupList.concat(p) : []);
                                        }}
                                        onClickSelectAll={() => { select([]); selectGroup([]); }} />
                                </section>
                                <ParticipantListWithSearch
                                    label="Overige gebruikers:"
                                    participants={theSelectedList}
                                    allparticipants={allsearchparticipants}
                                    onClickRemove={(p) => {
                                        select(theSelectedParticipantList ? theSelectedParticipantList.qWhere((y) => y.id !== p.id) : []);
                                    }
                                    }
                                    onClick={(p) => {
                                        select(selectedListAndClickedOne(theSelectedParticipantList, p));
                                    }}
                                />
                            </CollapsiblePanel>

                            <div className={cx('share-with-groups')}>Deel met groepen</div>
                            <CollapsiblePanel defaultOpened={false} label={theSelectedUsergroupList.length ? mapGroups(selectedparticipantgroupIDs, alltheusergroups) : 'Selecteer'}>
                                <section aria-label={'Groepen geselecteerd'} className={cx('top')}>
                                    <div className={cx('input-search-div')}>
                                        <div className={cx('input-search')}>
                                            <span className={cx('icon-search')}></span>
                                            <input placeholder="Zoeken..." name="q" ref="term" value={searchTermUsergroup} onChange={(x) => updateSearchTermGroup(x.target.value)} />
                                        </div>
                                    </div>
                                    <ParticipantAndUsergroupList label="" up={false}
                                        participants={theSelectedUsergroupList}
                                        allparticipants={alltheusergroups}
                                        onClick={(p) => {
                                            selectGroup(theSelectedUsergroupList ? theSelectedUsergroupList.qWhere((y) => y.id !== p.id) : []);
                                        }}
                                        onClickAdd={(p) => {
                                            selectGroup(theSelectedUsergroupList && isUsergroup(p) ? theSelectedUsergroupList.concat(p) : theSelectedUsergroupList);
                                        }}
                                        onClickSelectAll={() => { select([]); selectGroup([]); }} />
                                </section>
                                <UsergroupsListWithSearch
                                    usergroups={theSelectedUsergroupList}
                                    allusergroups={allsearchusergroups}
                                    onClick={(p) => {
                                        selectGroup(selectedListAndClickedOneUsergroup(theSelectedUsergroupList, p));
                                    }}
                                    onClickRemove={(p) => {
                                        return selectGroup(theSelectedUsergroupList ? theSelectedUsergroupList.qWhere((y) => y.id !== p.id) : []);
                                    }
                                    }
                                />
                            </CollapsiblePanel>

                        </section>
                    </div>
                </div>
            </div>
        );
    });

export const ParticipantAndUsergroupList = PureFunctional<{
    label: string;
    up: boolean;
    participants: (IParticipant | IUsergroup)[];
    allparticipants: (IParticipant | IUsergroup)[];
    onClick: (participant: IParticipant | IUsergroup) => void;
    onClickAdd: (participant: IParticipant | IUsergroup) => void;
    onClickSelectAll: () => void;
}>(`ParticipantList`)(
    ({ participants, onClick }) => {

        return (
            <div className={cx('list')}>
                {participants && participants.qSelect((participant: (IParticipant | IUsergroup)) => {
                    const isparticipant = isParticipant(participant);
                    const id: string | number = isparticipant ? participant.id : participant.id;
                    if (id)
                        return (
                            <div tabIndex={0} className={cx('selection-list')} key={`key` + `${isparticipant ? id.toString() : 'u-' + id}`}
                                onKeyDown={(ev) => { handleEnters(ev, () => onClick(participant)); }}
                                onClick={() => onClick(participant)}
                            >{participant.name}
                                <span className={cx('close')}></span>
                            </div>
                        );
                    return null;
                })}
            </div>

        );
    });

export const ParticipantListWithSearch = PureFunctional<{
    label: string;
    participants: IParticipant[];
    allparticipants: IParticipant[];
    onClick: (participant: IParticipant) => void;
    onClickRemove: (participant: IParticipant) => void;
}>(`ParticipantList`)(
    ({ participants, allparticipants, onClick, onClickRemove }) => {

        return (
            <div className={cx('list')}>
                {allparticipants && allparticipants.qSelect((participant) => {
                    return (<div tabIndex={0} key={`key` + `${participant.id.toString()}`} className={cx('item')}
                        onKeyDown={(ev) => {
                            ev.preventDefault(); handleEnters(ev, () =>
                                participants.includes(participant) ?
                                    onClickRemove(participant) :
                                    onClick(participant));
                        }}
                        onClick={(ev) => {
                            ev.preventDefault(); participants.includes(participant) ?
                                onClickRemove(participant) :
                                onClick(participant);
                        }}>
                        <label className={cx('selection-container')}>{participant.name}
                            <input type="checkbox" checked={participants.includes(participant)} onChange={() => null} />
                            <span className={cx('checkmark')}></span>
                        </label>

                    </div>);

                })}
            </div>

        );
    });

export const UsergroupsListWithSearch = PureFunctional<{
    usergroups: IUsergroup[];
    allusergroups: IUsergroup[];
    onClick: (usergroup: IUsergroup) => void;
    onClickRemove: (usergroup: IUsergroup) => void;
}>(`ParticipantList`)(
    ({ usergroups, allusergroups, onClick, onClickRemove }) => {

        return (
            <div className={cx('list')}>
                {allusergroups && allusergroups.qSelect((usergroup) => {

                    return (<div tabIndex={0} key={`key` + `${usergroup.id.toString()}`} className={cx('item')}
                        onKeyDown={(ev) => {
                            ev.preventDefault(); usergroups.includes(usergroup) ?
                                onClickRemove(usergroup) :
                                onClick(usergroup);
                        }}
                        onClick={(ev) => {
                            ev.preventDefault(); usergroups.includes(usergroup) ?
                                onClickRemove(usergroup) :
                                onClick(usergroup);
                        }}
                    >
                        <label className={cx('selection-container')}>{usergroup.name}
                            <input type="checkbox" checked={usergroups.includes(usergroup)} onChange={() => null} />
                            <span className={cx('checkmark')}></span>
                        </label>

                    </div>);
                })}
            </div>

        );
    });

export const ParticipantSelectionForFactions  = PureConnect<{
        label?: string;
        title?: string;
        selectedparticipantsIDs: string[];
        selectedparticipantgroupIDs: string[];
        participantPopupVisible: boolean;
        onChange: (participantids: string[]) => any;
        onChangeParticipantGroups: (participantgroupIDs: string[]) => any;
        onAbort: () => void;
        onSave: () => void;
    }>(`ParticipantSelectionForFactions`)(
        (state) => ({
        }),
        (dispatch) => ({
        }),
        ({ title, selectedparticipantsIDs, selectedparticipantgroupIDs, onChange, onChangeParticipantGroups, onAbort, onSave }) => {
    
            return (
                <ParticipantSelectForFactions
                    title={title}
                    selectedparticipantsIDs={selectedparticipantsIDs}
                    selectedparticipantgroupIDs={selectedparticipantgroupIDs}
                    onSelect={onChange}
                    onSelectGroup={onChangeParticipantGroups}
                />
            );
        });    

export const ParticipantSelectForFactions = PureConnect<{
        label?: string;
        title?: string;
        selectedparticipantsIDs: string[],
        selectedparticipantgroupIDs: string[],
        onSelect: (participantsids: string[]) => void;
        onSelectGroup: (participantgroupIDs: string[]) => void;
    }>(`ParticipantSelectForFactions`)(
        (state) => ({
            alltheparticipants: reselectors.AllParticipantSelector(state),
            allsearchparticipants: reselectors.FactionParticipantSelector(state),
            alltheusergroups: reselectorsug.AllUsergroupSelector(state),
            allsearchusergroups: reselectorsug.UsergroupSelector(state),
            usergroups: usergroupResource.selectors.items(state),
            screenSmall: windowSelectors.small(state),
            searchTermParticipant: selectors.searchTermParticipantSelector(state),
            searchTermUsergroup: selectors.searchTermUsergroupSelector(state),
        }),
        (dispatch, { onSelect, onSelectGroup }) => ({
            cancel() { dispatch(CANCEL({})); },
            save() { dispatch(CANCEL({})); },
            select(participants: IParticipant[]) { onSelect(participants.qSelect((x) => x.id)); dispatch(SELECT({ participants })); },
            selectGroup(usergroups: IUsergroup[]) { onSelectGroup(usergroups.qSelect((y) => y.id.toString())); dispatch(SELECT_GROUP({ usergroups })); },
            updateSearchTerm: (searchTerm: string) => { dispatch(SEARCH_TERM({ searchTermParticipant: searchTerm })); },
            updateSearchTermGroup: (searchTerm: string) => { dispatch(SEARCH_TERM_USERGROUP({ searchTermUsergroup: searchTerm })); },
        }),
        ({ title, searchTermParticipant, searchTermUsergroup, usergroups, alltheparticipants, allsearchparticipants, selectedparticipantsIDs, alltheusergroups, allsearchusergroups, selectedparticipantgroupIDs, cancel, save, select, selectGroup, updateSearchTerm, updateSearchTermGroup }) => {
            const allparticipants: (any)[] = [];
            if (alltheparticipants && alltheparticipants.length)
                alltheparticipants.qWhere((itm) => allparticipants && !allparticipants.qAny((itmpart) => itmpart === itm)).map((itm) => allparticipants.push(itm));
            if (alltheusergroups && alltheusergroups.length)
                alltheusergroups.qWhere((itm) => allparticipants && !allparticipants.qAny((itmpart) => itmpart === itm)).map((ug) => allparticipants.push(ug));
            const theSelectedList: any[] = alltheparticipants.qWhere((participant) =>
                (selectedparticipantsIDs ? selectedparticipantsIDs.qIncludes(participant.id) : false));
    
            const notSelectedList: any[] = allsearchparticipants
            .qWhere((participant) =>
                (selectedparticipantsIDs ? !selectedparticipantsIDs.qIncludes(participant.id) : true));
            // the participants
            const theSelectedParticipantList: IParticipant[] = alltheparticipants.qWhere((participant) =>
                (selectedparticipantsIDs ? selectedparticipantsIDs.qIncludes(participant.id) : false));
    
            // the usergroups             
            const theSelectedUsergroupList: IUsergroup[] = alltheusergroups.qWhere((usergroup) =>
                (selectedparticipantgroupIDs ? selectedparticipantgroupIDs.qSelect((x) => parseInt(x)).qIncludes(usergroup.id) : false));
            theSelectedUsergroupList.map((tsu) => theSelectedList.push(tsu));
    
            const notSelectedUsergroupList: IUsergroup[] = allsearchusergroups.qWhere((usergroup) =>
                (selectedparticipantgroupIDs ? !selectedparticipantgroupIDs.qSelect((x) => parseInt(x)).qIncludes(usergroup.id) : true));
    
            notSelectedUsergroupList.map((nsu) => notSelectedList.push(nsu));

            return (
                <div className={cx('fields-container')} aria-hidden={false} aria-labelledby="Selecteer deelnemers">               
                    <div className={cx('container')}>
                        <div className={cx('selectable-aria')}>
                            <div className={cx('share-with-persons')}>{title && title.length ? title : 'Leden van de groep'}</div>
                            <section aria-label={'Selecteer deelnemer'} className={cx('bottom')}>
                                <CollapsiblePanel defaultOpened={false} label={theSelectedList.length ? mapParticipantsNames(selectedparticipantsIDs, allparticipants) : 'Selecteer'}>
                                    <div className={cx('input-search-div')}>
                                        <div className={cx('input-search')}>
                                            <span className={cx('icon-search')}></span>
                                            <input placeholder="Zoeken..." name="q" ref="term" value={searchTermParticipant} onChange={(x) => updateSearchTerm(x.target.value)} />
                                        </div>
                                    </div>
                                    <section aria-label={'Deelnemers'} className={cx('top')}>
                                        <ParticipantAndUsergroupList label="" up={false}
                                            participants={theSelectedParticipantList}
                                            allparticipants={allparticipants}
                                            onClick={(p) => {
                                                isParticipant(p) ?
                                                    select(theSelectedParticipantList ? theSelectedParticipantList.qWhere((y) => y.id !== p.id) : []) :
                                                    selectGroup(theSelectedUsergroupList ? theSelectedUsergroupList.qWhere((y) => y.id !== p.id) : []);
                                            }}
                                            onClickAdd={(p) => {
                                                isParticipant(p) ?
                                                    select(theSelectedParticipantList ? theSelectedParticipantList.concat(p) : []) :
                                                    selectGroup(theSelectedUsergroupList ? theSelectedUsergroupList.concat(p) : []);
                                            }}
                                            onClickSelectAll={() => { select([]); selectGroup([]); }} />
                                    </section>
                                    <ParticipantListWithSearch
                                        label="Overige gebruikers:"
                                        participants={theSelectedList}
                                        allparticipants={allsearchparticipants}
                                        onClickRemove={(p) => {
                                            select(theSelectedParticipantList ? theSelectedParticipantList.qWhere((y) => y.id !== p.id) : []);
                                        }
                                        }
                                        onClick={(p) => {
                                            select(selectedListAndClickedOne(theSelectedParticipantList, p));
                                        }}
                                    />
                                </CollapsiblePanel>
                            </section>
                        </div>
                    </div>
                </div>
            );
        });

export const ParticipantSelectionForUsergroups  = PureConnect<{
    label?: string;
    title?: string;
    selectedparticipantsIDs: string[];
    selectedparticipantgroupIDs: string[];
    participantPopupVisible: boolean;
    onChange: (participantids: string[]) => any;
    onChangeParticipantGroups: (participantgroupIDs: string[]) => any;
    onAbort: () => void;
    onSave: () => void;
}>(`ParticipantSelectionForUsergroups`)(
    (state) => ({
        // participants: participantsResource.selectors.items(state),
        // usergroups: usergroupResource.selectors.items(state),
    }),
    (dispatch) => ({
    }),
    ({ title, selectedparticipantsIDs, selectedparticipantgroupIDs, onChange, onChangeParticipantGroups, onAbort, onSave }) => {

        return (
            <ParticipantSelectForUsergroups
                title={title}
                selectedparticipantsIDs={selectedparticipantsIDs}
                selectedparticipantgroupIDs={selectedparticipantgroupIDs}
                onSelect={onChange}
                onSelectGroup={onChangeParticipantGroups}
            />
        );
    });

export const ParticipantSelectForUsergroups = PureConnect<{
        label?: string;
        title?: string;
        selectedparticipantsIDs: string[],
        selectedparticipantgroupIDs: string[],
        onSelect: (participantsids: string[]) => void;
        onSelectGroup: (participantgroupIDs: string[]) => void;
    }>(`ParticipantSelectForUsergroups`)(
        (state) => ({
            alltheparticipants: reselectors.AllParticipantSelector(state),
            allsearchparticipants: reselectors.ParticipantSelector(state),
            alltheusergroups: reselectorsug.AllUsergroupSelector(state),
            allsearchusergroups: reselectorsug.UsergroupSelector(state),
            usergroups: usergroupResource.selectors.items(state),
            screenSmall: windowSelectors.small(state),
            searchTermParticipant: selectors.searchTermParticipantSelector(state),
            searchTermUsergroup: selectors.searchTermUsergroupSelector(state),
        }),
        (dispatch, { onSelect, onSelectGroup }) => ({
            cancel() { dispatch(CANCEL({})); },
            save() { dispatch(CANCEL({})); },
            select(participants: IParticipant[]) { onSelect(participants.qSelect((x) => x.id)); dispatch(SELECT({ participants })); },
            selectGroup(usergroups: IUsergroup[]) { onSelectGroup(usergroups.qSelect((y) => y.id.toString())); dispatch(SELECT_GROUP({ usergroups })); },
            updateSearchTerm: (searchTerm: string) => { dispatch(SEARCH_TERM({ searchTermParticipant: searchTerm })); },
            updateSearchTermGroup: (searchTerm: string) => { dispatch(SEARCH_TERM_USERGROUP({ searchTermUsergroup: searchTerm })); },
        }),
        ({ title, searchTermParticipant, searchTermUsergroup, alltheparticipants, allsearchparticipants, selectedparticipantsIDs, alltheusergroups, allsearchusergroups, selectedparticipantgroupIDs, cancel, save, select, selectGroup, updateSearchTerm, updateSearchTermGroup }) => {
            const allparticipants: (any)[] = [];
            if (alltheparticipants && alltheparticipants.length)
                alltheparticipants.qWhere((itm) => allparticipants && !allparticipants.qAny((itmpart) => itmpart === itm)).map((itm) => allparticipants.push(itm));
            if (alltheusergroups && alltheusergroups.length)
                alltheusergroups.qWhere((itm) => allparticipants && !allparticipants.qAny((itmpart) => itmpart === itm)).map((ug) => allparticipants.push(ug));
            const theSelectedList: any[] = alltheparticipants.qWhere((participant) =>
                (selectedparticipantsIDs ? selectedparticipantsIDs.qIncludes(participant.id) : false));
    
            const notSelectedList: any[] = allsearchparticipants.qWhere((participant) =>
                (selectedparticipantsIDs ? !selectedparticipantsIDs.qIncludes(participant.id) : true));
    
            // the participants
            const theSelectedParticipantList: IParticipant[] = alltheparticipants.qWhere((participant) =>
                (selectedparticipantsIDs ? selectedparticipantsIDs.qIncludes(participant.id) : false));
    
            // the usergroups             
            const theSelectedUsergroupList: IUsergroup[] = alltheusergroups.qWhere((usergroup) =>
                (selectedparticipantgroupIDs ? selectedparticipantgroupIDs.qSelect((x) => parseInt(x)).qIncludes(usergroup.id) : false));
            theSelectedUsergroupList.map((tsu) => theSelectedList.push(tsu));
    
            const notSelectedUsergroupList: IUsergroup[] = allsearchusergroups.qWhere((usergroup) =>
                (selectedparticipantgroupIDs ? !selectedparticipantgroupIDs.qSelect((x) => parseInt(x)).qIncludes(usergroup.id) : true));
    
            notSelectedUsergroupList.map((nsu) => notSelectedList.push(nsu));

            return (
                <div className={cx('fields-container')} aria-hidden={false} aria-labelledby="Selecteer deelnemers">               
                    <div className={cx('container')}>
                        <div className={cx('selectable-aria')}>
                            <div className={cx('share-with-persons')}>{title && title.length ? title : 'Leden van de groep'}</div>
                            <section aria-label={'Selecteer deelnemer'} className={cx('bottom')}>
                                <CollapsiblePanel defaultOpened={false} label={theSelectedList.length ? mapParticipantsNames(selectedparticipantsIDs, allparticipants) : 'Selecteer'}>
                                    <div className={cx('input-search-div')}>
                                        <div className={cx('input-search')}>
                                            <span className={cx('icon-search')}></span>
                                            <input placeholder="Zoeken..." name="q" ref="term" value={searchTermParticipant} onChange={(x) => updateSearchTerm(x.target.value)} />
                                        </div>
                                    </div>
                                    <section aria-label={'Deelnemers'} className={cx('top')}>
                                        <ParticipantAndUsergroupList label="" up={false}
                                            participants={theSelectedParticipantList}
                                            allparticipants={allparticipants}
                                            onClick={(p) => {
                                                isParticipant(p) ?
                                                    select(theSelectedParticipantList ? theSelectedParticipantList.qWhere((y) => y.id !== p.id) : []) :
                                                    selectGroup(theSelectedUsergroupList ? theSelectedUsergroupList.qWhere((y) => y.id !== p.id) : []);
                                            }}
                                            onClickAdd={(p) => {
                                                isParticipant(p) ?
                                                    select(theSelectedParticipantList ? theSelectedParticipantList.concat(p) : []) :
                                                    selectGroup(theSelectedUsergroupList ? theSelectedUsergroupList.concat(p) : []);
                                            }}
                                            onClickSelectAll={() => { select([]); selectGroup([]); }} />
                                    </section>
                                    <ParticipantListWithSearch
                                        label="Overige gebruikers:"
                                        participants={theSelectedList}
                                        allparticipants={allsearchparticipants}
                                        onClickRemove={(p) => {
                                            select(theSelectedParticipantList ? theSelectedParticipantList.qWhere((y) => y.id !== p.id) : []);
                                        }
                                        }
                                        onClick={(p) => {
                                            select(selectedListAndClickedOne(theSelectedParticipantList, p));
                                        }}
                                    />
                                </CollapsiblePanel>
                            </section>
                        </div>
                    </div>
                </div>
            );
        });

export const ParticipantListOfUsergroups = PureConnect<{
            selectedparticipantsIDs: string[],
        }>(`ParticipantListOfUsergroups`)(
            (state) => ({
                alltheparticipants: reselectors.AllParticipantSelector(state),
                screenSmall: windowSelectors.small(state),
            }),
            (dispatch) => ({
            }),
            ({ alltheparticipants,  selectedparticipantsIDs }) => {
                
                const allparticipants: (any)[] = [];
                if (alltheparticipants && alltheparticipants.length)
                    alltheparticipants.qWhere((itm) => allparticipants && !allparticipants.qAny((itmpart) => itmpart === itm)).map((itm) => allparticipants.push(itm));
                const theSelectedList: any[] = alltheparticipants.qWhere((participant) =>
                    (selectedparticipantsIDs ? selectedparticipantsIDs.qIncludes(participant.id) : false));
         
                return (
                    <div className={cx('component') }>
                        <div className={cx('header')}>
                            {theSelectedList.length ? mapParticipantsNames(selectedparticipantsIDs, allparticipants): ''}
                        </div>
                    </div>
                );
            });
    
function handleEnters(evt: React.KeyboardEvent<HTMLDivElement>, funct: () => void) {
    if (evt.key === 'Enter') { evt.preventDefault(); funct(); }
}

function selectedListAndClickedOne(items: IParticipant[], newone: IParticipant) {
    if (items && !items.qAny((itm) => itm.id === newone.id))
        items.push(newone);
    return items;
}

function selectedListAndClickedOneUsergroup(items: IUsergroup[], newone: IUsergroup) {
    if (items && !items.qAny((itm) => itm.id === newone.id))
        items.push(newone);
    return items;
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/noteParticipantSelectPopup/input.tsx